module.exports = __webpack_public_path__ + "static/media/transfer.915ed21d.svg";